import {
  AnchorBasic,
  BodyDefaultTypography,
  BodySmallTypography,
  BREAKPOINT,
  Heading,
} from '@npco/zeller-design-system'
import styled from 'styled-components'

export const InterestHeading = styled.h3`
  ${BodyDefaultTypography}
  font-weight: 600;
  margin: 0;
`

export const InterestText = styled.p`
  ${BodySmallTypography};
  margin: 0;
`

export const InterestEmphasis = styled.b`
  font-weight: 600;
`

export const TermsAndConditionsText = styled.div`
  color: ${({ theme }) => theme.colors.GREY_550};
  ${BodySmallTypography}
  margin: 0;
`

export const TermsAndConditionsLink = styled(AnchorBasic)`
  color: ${({ theme }) => theme.colors.GREY_550};
  ${BodySmallTypography}
  margin: 0;
  text-decoration: underline;

  &:hover {
    text-decoration-color: ${({ theme }) => theme.colors.GREY_550};
  }
`

export const Title = styled(Heading.H1)`
  font-size: 24px;
  line-height: 32px;
  @media screen and (min-width: ${BREAKPOINT.XS}px) {
    font-size: 32px;
    line-height: 40px;
  }
`
